module.exports = __webpack_public_path__ + "90e08e954d03a80a6e1095cd7d0932b1.png";